import { render, staticRenderFns } from "./FilterReleaseYear.vue?vue&type=template&id=acafa4f2"
import script from "./FilterReleaseYear.vue?vue&type=script&lang=ts"
export * from "./FilterReleaseYear.vue?vue&type=script&lang=ts"
import style0 from "./FilterReleaseYear.vue?vue&type=style&index=0&id=acafa4f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports